import React, { useState } from 'react';
import Navbar from '../components/navbar/navbar';
import Footer from '../components/footer/footer';
import './Blog.css';
import SEO from '../components/SEO';

const POSTS = [
  { id: 1, title: "Subscription vs. Commissions: A New Era for Drivers", category: "Product", date: "July 20, 2026", desc: "Why taking 25% of fares hurts drivers, and how flat-rate weekly subscriptions solve the ride-hailing earnings crisis." },
  { id: 2, title: "The Private Chef Boom: Delivering Fine Dining at Home", category: "Culinary", date: "July 15, 2026", desc: "Insulated hot bag technology and dedicated delivery routes are bringing artisan chef meals to diners in under 30 minutes." },
  { id: 3, title: "Top 5 Safety Tips for Night-Shift Logistics Couriers", category: "Safety", date: "July 10, 2026", desc: "From GPS route pre-checks to illuminated vest setups, how bicycle and motorbike dispatchers stay secure on city streets." }
];

function Blog() {
  const [email, setEmail] = useState('');
  const [subscribed, setSubscribed] = useState(false);

  const handleSubscribe = (e) => {
    e.preventDefault();
    if (email) {
      setSubscribed(true);
    }
  };

  return (
    <div className="blog-page-wrapper">
      <SEO 
        title="The 9tro Journal - News & Stories"
        description="Read company updates, driver stories, and culinary guides from the 9tro Ride team."
        url="https://www.9troride.com/blog"
      />
      <Navbar showSubNavbar={false} />

      <section className="blog-hero">
        <div className="blog-hero-container">
          <span className="hero-tag">Company News</span>
          <h1>The 9tro Journal</h1>
          <p>Guides, success stories, and updates from our transit, culinary, and logistics network.</p>
        </div>
      </section>

      {/* Featured Post */}
      <section className="featured-post-section">
        <div className="featured-post-container">
          <div className="featured-card">
            <span className="feat-badge">Featured Story</span>
            <h2>How flat subscriptions are putting ₦200,000 back in drivers' wallets monthly</h2>
            <p>Every month, traditional ride-hailing apps extract hundreds of thousands of Naira in commission fees. We sat down with Lagos partner driver Segun Alao to break down his earnings and look at how 9tro's subscription model shifts power back to the road.</p>
            <div className="feat-meta">
              <span className="feat-author">By 9tro Press Desk</span>
              <span className="feat-divider">•</span>
              <span className="feat-date">July 22, 2026</span>
            </div>
          </div>
        </div>
      </section>

      {/* Blog Grid */}
      <section className="blog-grid-section">
        <div className="blog-grid-container">
          <h2>Recent Articles</h2>
          <div className="blog-grid">
            {POSTS.map(post => (
              <div key={post.id} className="blog-card">
                <div className="blog-card-meta">
                  <span className="blog-category-badge">{post.category}</span>
                  <span className="blog-date">{post.date}</span>
                </div>
                <h3>{post.title}</h3>
                <p>{post.desc}</p>
                <button className="read-more-btn">Read Article →</button>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Newsletter Signup */}
      <section className="newsletter-section">
        <div className="newsletter-container">
          <h2>Get monthly updates sent to your inbox</h2>
          <p>Join our newsletter to receive company announcements, driver plan offers, and chef deals.</p>
          {subscribed ? (
            <div className="newsletter-success">
              <p>🎉 Thank you! You have been successfully subscribed to our newsletter.</p>
            </div>
          ) : (
            <form onSubmit={handleSubscribe} className="newsletter-form">
              <input 
                type="email" 
                placeholder="Enter your email address" 
                required 
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
              <button type="submit">Subscribe</button>
            </form>
          )}
        </div>
      </section>

      <Footer />
    </div>
  );
}

export default Blog;
